import React, { useState } from 'react'
import Button from 'react-bootstrap/Button'
import Modal from 'react-bootstrap/Modal'
import PropTypes from 'prop-types'
import { deleteData } from '../../actions/servicesHttp'
import { popupSimple } from '../generals/popups'
import { useTranslation } from 'react-i18next'
import { useNavigate } from 'react-router-dom'

export default function ModalDeleteGroupPreference ({ onHide, title, show, btnError, btnSuccess, group }) {
  // ? urls de la API
  const [groupPreferenceUrl] = useState('preferences/group')
  const { t } = useTranslation('dashboardGroup')
  const navigate = useNavigate()

  const deleteGroupPreference = async (url, id, navigate) => {
    const { data } = await deleteData(url, id, navigate)

    if (data.result) {
      popupSimple('success', t('message9'))
    } else {
      popupSimple('error', t('message10'))
    }

    onHide()
  }

  return (
        <>
            <Modal
                show={show}
                onHide={onHide}
                size="md"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                key={'deleteGroupPreference'}
            >
                <Modal.Header closeButton>
                    <Modal.Title id="example-custom-modal-styling-title">
                        {title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <p>{t('label21')}</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <Button onClick={onHide} variant="danger">
                        {btnError}
                    </Button>
                    <Button onClick={() => deleteGroupPreference(groupPreferenceUrl, group[0], navigate)} variant="primary" id="btnModalSucess" >
                        {btnSuccess}
                    </Button>
                </Modal.Footer>
            </Modal>
        </>
  )
}

ModalDeleteGroupPreference.propTypes = {
  onHide: PropTypes.func,
  title: PropTypes.string,
  show: PropTypes.bool,
  btnError: PropTypes.string,
  btnSuccess: PropTypes.string,
  group: PropTypes.number
}
